import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { PartnerDetail } from '../types/types.ts';
import SmileIcon from '../assets/images/icons/icon-smile.png';
import { IMAGE_BASE_URL } from '../constants/config.ts';

type SortablePartnerItemProps = {
  id: string;
  partner: PartnerDetail;
  handlePartnerClick: (id: PartnerDetail) => void;
};
export const SortablePartnerItem: React.FC<SortablePartnerItemProps> = ({ id, partner, handlePartnerClick }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div className="partner-item  position-relative" ref={setNodeRef} style={style} {...attributes}>
      <div className="partner-item__image_holder" {...listeners}>
        <img
          src={partner.image !== null && partner.image !== 'unknown' ? `${IMAGE_BASE_URL}/${partner.image}` : SmileIcon}
          alt={partner.name || 'Partner'}
        />
      </div>
      <div onClick={() => handlePartnerClick(partner)} className="partner-item__cancel">
        x
      </div>
      <p className="fz-14 text-center partner-name">{partner.name}</p>
    </div>
  );
};
